import { useState } from "react";
import Card from "react-bootstrap/Card";
import Badge from "react-bootstrap/Badge";
import Button from "react-bootstrap/Button";
import ServiceOptionToolTipModal from "components/Customize/ServiceOptionToolTipModal";

function ServiceOption({
  option,
  optionDefinition,
  onChangeServiceOptionAmount,
}: {
  option: any;
  optionDefinition: any;
  onChangeServiceOptionAmount: (cartServiceOptionId: number, selectedQuantity: number) => void;
}) {
  const [showDetails, setShowDetails] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  const content = optionDefinition?.contentEcommerce.reduce((a: any, item: any) => {
    a[item.fieldName] = item;
    return a;
  }, {});

  let selectOption = null;
  if (option.availableQuantity === 1) {
    const selected = option.selectedQuantity === 1;
    selectOption = (
      <Card.Footer className="p-0">
        <Button
          variant={selected ? "" : "primary"}
          disabled={!option.isEnabledForSelection}
          className={`w-100 text-center no-radius ${selected ? "border-bg-pastel-light-blue" : "customize-service-option-footer-add-item"}`}
          onClick={() => {
            onChangeServiceOptionAmount(option.id, selected ? 0 : 1);
          }}
        >
          <small className="text-white">
            {selected && <i className="text-white fa-sharp fa-solid fa-check me-1"></i>}
            {selected ? "Added" : "Add item"}
          </small>
        </Button>
      </Card.Footer>
    );
  } else if (option.availableQuantity > 1) {
    let options = [];
    for (let i = option.currentQuantity; i <= option.availableQuantity; i++) {
      options.push(
        <option key={i} value={i}>
          {i}
        </option>
      );
    }
    selectOption = (
      <Card.Footer className="customize-service-option-footer-add-item text-center no-radius d-flex justify-content-around align-items-center">
        <small className="text-white">Select quantity</small>
        <select
          value={option.selectedQuantity}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
            onChangeServiceOptionAmount(option.id, parseInt(e.target.value));
          }}
        >
          {options}
        </select>
      </Card.Footer>
    );
  }

  const showOverlay = option.categoryName !== "Camera" && !option.isEnabledForSelection && option.selectedQuantity < 1;

  return (
    <Card className="no-radius">
      {showOverlay && <div className="customize-service-option-disabled-overlay"></div>}
      <Card.Img variant="top" className="customize-service-option-img-bg p-4 no-radius" src={content?.icon?.fileURL} />
      <Card.Body className="customize-service-option-body d-flex flex-column">
        <div className="text-center">
          <div>
            {content?.copy?.content}
            {content?.toolTip && (
              <>
                <Badge
                  pill
                  className="ms-1 bg-pastel-lig"
                  role="button"
                  bg="primary"
                  onClick={() => {
                    setShowTooltip(true);
                  }}
                >
                  <i className="fa-sharp fa-solid fa-info"></i>
                </Badge>
                <ServiceOptionToolTipModal
                  show={showTooltip}
                  link={content.toolTip.content}
                  handleClose={() => {
                    setShowTooltip(false);
                  }}
                />
              </>
            )}
          </div>
          {content?.inlineDetails && (
            <>
              <div>
                <Button onClick={() => setShowDetails(!showDetails)} className="text-decoration-none" variant="link">
                  <small>{showDetails ? "Hide details" : "View details"}</small>
                </Button>
              </div>
              {showDetails && <div className="px-3" dangerouslySetInnerHTML={{ __html: content.inlineDetails.content }}></div>}
            </>
          )}
        </div>
        <div style={{ flex: 1 }}></div>
        <div className="text-center">
          <div>
            <s>{option.price}</s>
          </div>
          <div className="customize-price-text">{option.displayPrice}</div>
        </div>
      </Card.Body>
      {selectOption}
    </Card>
  );
}

export default ServiceOption;
